var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircularBgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.717,
    height: 257.718,
    viewBox: "0 0 257.717 257.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1487",
    "data-name": "Rectangle 1487",
    width: 257.717,
    height: 257.718,
    fill: "#e9f5f1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M128.86,257.718a128.859,128.859,0,1,1,128.858-128.86A129.006,129.006,0,0,1,128.86,257.718m0-252.576A123.717,123.717,0,1,0,252.575,128.857,123.857,123.857,0,0,0,128.86,5.142",
    transform: "translate(0 0)",
    fill: "#e9f5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M123.667,236.439A112.772,112.772,0,1,1,236.437,123.666,112.9,112.9,0,0,1,123.667,236.439m0-220.4A107.63,107.63,0,1,0,231.3,123.666,107.752,107.752,0,0,0,123.667,16.037",
    transform: "translate(5.193 5.193)",
    fill: "#e9f5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M118.474,215.157a96.684,96.684,0,1,1,96.684-96.685,96.793,96.793,0,0,1-96.684,96.685m0-188.227a91.542,91.542,0,1,0,91.541,91.542,91.645,91.645,0,0,0-91.541-91.542",
    transform: "translate(10.385 10.385)",
    fill: "#e9f5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M113.282,193.878a80.6,80.6,0,1,1,80.6-80.6,80.688,80.688,0,0,1-80.6,80.6m0-156.051a75.454,75.454,0,1,0,75.455,75.454,75.541,75.541,0,0,0-75.455-75.454",
    transform: "translate(15.578 15.578)",
    fill: "#e9f5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M108.089,172.6A64.509,64.509,0,1,1,172.6,108.087,64.583,64.583,0,0,1,108.089,172.6m0-123.877a59.367,59.367,0,1,0,59.366,59.366,59.435,59.435,0,0,0-59.366-59.366",
    transform: "translate(20.77 20.771)",
    fill: "#e9f5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M102.9,151.318A48.422,48.422,0,1,1,151.318,102.9,48.478,48.478,0,0,1,102.9,151.318m0-91.7a43.28,43.28,0,1,0,43.28,43.28,43.329,43.329,0,0,0-43.28-43.28",
    transform: "translate(25.963 25.964)",
    fill: "#e9f5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M97.7,130.037A32.334,32.334,0,1,1,130.037,97.7,32.371,32.371,0,0,1,97.7,130.037m0-59.527A27.193,27.193,0,1,0,124.9,97.7,27.223,27.223,0,0,0,97.7,70.51",
    transform: "translate(31.156 31.156)",
    fill: "#e9f5f1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularBgGreen);
export default __webpack_public_path__ + "static/media/circular-bg-green.8bcb497ce5ccba4d84bc734847978feb.svg";
export { ForwardRef as ReactComponent };